export const existsInTable = (data, tableName, columnNames, searchValues) => {
  if (columnNames.length !== searchValues.length) {
    throw new Error('Expecting columnNames and searchValues to have the same length.')
  }
  let tableData;
  if (!tableName) {
    tableData = data
  } else {
    tableData = data[tableName]
  }

  for (let i = 0; i < tableData.length; i++) {
    for (let j = 0; j < columnNames.length; j++) {
      const columnName = columnNames[j];
      const searchValue = searchValues[j];
      if (searchValue !== tableData[i][columnName]) {
        break;
      }
      if (j === columnNames.length - 1) {
        return {exists: true, index:i}
      }
    }
  }
  return {exists: false};
}

const columnMatches = (cellValue, searchValue, matchType) => {
  if (!searchValue) return true;
  if (matchType === 'in') return !!(cellValue && cellValue.indexOf(searchValue) >= 0);
  return cellValue === searchValue;
};

export const findAllEntriesInTable = (data, tableName, columnNames, searchValues, matchTypes=null) => {
  const idcs = [];
  if (columnNames.length !== searchValues.length) {
    throw new Error('Expecting columnNames and searchValues to have the same length.')
  }
  for (let i = 0; i < data[tableName].length; i++) {
    const allMatch = columnNames.every((columnName, j) =>
      columnMatches(data[tableName][i][columnName], searchValues[j], matchTypes && matchTypes[j])
    );
    if (allMatch) idcs.push(i);
  }
  return idcs;
}

//gets the value in returnColumn that matches the criteria in searchValues
export const getValueAt = (data, tableName, columnNames, searchValues, returnColumn) => {
  const existanceCheck = existsInTable(data, tableName, columnNames, searchValues);
  if (existanceCheck.exists) {
    let tableData;
    if (!tableName) {
      tableData = data;
    } else {
      tableData = data[tableName]
    }
    const value = tableData[existanceCheck.index][returnColumn]
    return {exists:true, value:value}
  } else {
    return {exists:false}
  }
}

export const getRowAt = (data, tableName, columnNames, searchValues) => {

  const existanceCheck = existsInTable(data, tableName, columnNames, searchValues);
  if (existanceCheck.exists) {
    const value = data[tableName][existanceCheck.index]
    return {exists:true, value:value}
  } else {
    return {exists:false}
  }  
}

export const addCoordsToTrip = (data, tripRow, lookupTable) => {
  //this function adds the to/from coordinates to the trip row based on the location names
  const fromLocation = tripRow['fromLocationName'];
  const toLocation = tripRow['toLocationName'];


  const fromLat = getValueAt(data, lookupTable, ['locationName'], [fromLocation], 'latitude');
  const fromLng = getValueAt(data, lookupTable, ['locationName'], [fromLocation], 'longitude');
  const toLat = getValueAt(data, lookupTable, ['locationName'], [toLocation], 'latitude');
  const toLng = getValueAt(data, lookupTable, ['locationName'], [toLocation], 'longitude');
  
  tripRow['fromLatitude'] = fromLat.value;
  tripRow['fromLongitude'] = fromLng.value;
  tripRow['toLatitude'] = toLat.value;
  tripRow['toLongitude'] = toLng.value;

  return tripRow
}

//deletes entries in data where colName == value. data should be a 
//list of json objects
export const deleteWhere = (data, tableName, colName, value) => {
  const removeIndices = [];
  data[tableName].forEach((elem, idx) => {
    if (elem[colName] === value) {
      removeIndices.unshift(idx);
    }
  });
  removeIndices.forEach((elem) => {
    data[tableName].splice(elem, 1);
  })

  return data
}
